import { Injector, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, of, switchMap, take } from 'rxjs';

import { selectIsDashboardEnabled } from '@core/stores/auth/auth.selectors';
import { TenantsStore } from '@core/stores/tenants/tenants.store';

import { isDefined } from '@shared/utils/is-defined';

import { createSitesDefaultRedirectCommandFrom$ } from './sites-default-redirect';

export const dashboardEnabledCanActivateGuard: CanActivateFn = () => {
  const store = inject(Store);
  const tenantsStore = inject(TenantsStore);
  const router = inject(Router);
  const injector = inject(Injector);

  return store.select(selectIsDashboardEnabled).pipe(
    filter(isDefined),
    take(1),
    switchMap((isEnabled) => (isEnabled ? of(true) : createSitesDefaultRedirectCommandFrom$(tenantsStore, router, injector)))
  );
};
